export default "__VITE_ASSET__bd3781b8__"